import React from 'react';
import {
  ActionCardContainer,
  ActionIconContainer,
  ActionCardTitle,
  ActionCardDescription,
  ActionButton,
} from './styles';
import { useNavigate } from "react-router-dom";

export default function ActionCard({ title, description, buttonText, type, icon }) {
  const navigate = useNavigate();

  function handleClick() {
    if (type === "evento") navigate("/criar-evento");
    if (type === "oportunidade") navigate("/criar-oportunidade");
    if (type === "curso") navigate("/novo-curso");
  }

  return (
    <ActionCardContainer>
      {/* Ícone renderizado diretamente */}
      <ActionIconContainer type={type}>
        {icon}  {/* <- renderiza o ícone passado por props */}
      </ActionIconContainer>

      <ActionCardTitle>{title}</ActionCardTitle>
      <ActionCardDescription>{description}</ActionCardDescription>

      <ActionButton type={type} onClick={handleClick}>
        {buttonText}
      </ActionButton>
    </ActionCardContainer>
  );
}
